/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import classNames from 'classnames';
import { useFormik } from 'formik';
import { useRouter } from 'next/router';

import { Currency, Filter } from '@/icons/index';
import { Button, DropDownFilter, Input } from '@/ui/index';

import styles from './styles.module.scss';

const FiltersBlock = ({
  type,
  subscription,
  advantages,
  applyText,
  resetText,
  maxText,
  minText,
}) => {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const formik = useFormik({
    initialValues: {
      from: '',
      to: '',
      type: '',
      subscription: '',
      advantages: '',
    },
    onSubmit: (values) => {
      const type = values.type.map((item) => item.id);
      const subscription = values.subscription.map((item) => item.id);
      const advantages = values.advantages.map((item) => item.id);
      setOpen(false);
      router.push(
        {
          pathname: router.pathname,
          query: {
            ...router.query,
            priceFrom: values.from,
            priceTo: values.to,
            type: type.join(','),
            subscription: subscription.join(','),
            advantages: advantages.join(','),
          },
        },
        undefined,
        { shallow: true },
      );
    },
  });

  useEffect(() => {
    document.documentElement.classList[open ? 'add' : 'remove']('overflow');
  }, [open]);

  const getValueByType = (select, valueType) => {
    const value = router.query[valueType];
    if (value) {
      return select.filter((item) => value.includes(String(item.id)));
    }

    return [];
  };

  useEffect(() => {
    if (router.isReady) {
      formik.setValues({
        from: router.query.priceFrom || '',
        to: router.query.priceTo || '',
        type: getValueByType(type?.tags, 'type'),
        subscription: getValueByType(subscription?.tags, 'subscription'),
        advantages: getValueByType(advantages?.tags, 'advantages'),
      });
    }
  }, [router.isReady, router.query]);

  const onCloseModal = (event) => {
    if (event.target.classList.contains(styles.modal)) {
      setOpen(false);
    }
  };

  const resetForm = () => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          dynamicPage: router.query.dynamicPage,
        },
      },
      undefined,
      {
        shallow: true,
      },
    );
    formik.resetForm({
      values: {
        from: '',
        to: '',
        type: [type[0]],
        subscription: [subscription[0]],
        advantages: [advantages[0]],
      },
    });
  };

  return (
    <div
      className={styles.container}
      itemScope
      itemType='http://schema.org/ItemList'
    >
      <div className={'wrapper'} onClick={onCloseModal}>
        <button
          aria-label='Bakcell'
          className={styles.filters}
          onClick={() => setOpen(true)}
        >
          <Filter />
          <span>Filter tariffs</span>
        </button>
        <div className={classNames([styles.modal, { [styles.active]: open }])}>
          <div className={styles.content}>
            <button
              aria-label='Bakcell'
              className={styles.close}
              onClick={() => setOpen(false)}
            >
              Close
            </button>
            <span className={styles.title}>Filters</span>
            <div className={styles.dropdown}>
              {type && (
                <DropDownFilter
                  title={type.title}
                  onSelect={(item) => formik.setFieldValue('type', item)}
                  data={type.tags}
                  active={formik.values.type}
                />
              )}
              {subscription && (
                <DropDownFilter
                  title={subscription.title}
                  onSelect={(item) =>
                    formik.setFieldValue('subscription', item)
                  }
                  data={subscription.tags}
                  active={formik.values.subscription}
                />
              )}
              {advantages && (
                <DropDownFilter
                  title={advantages.title}
                  onSelect={(item) => formik.setFieldValue('advantages', item)}
                  data={advantages.tags}
                  active={formik.values.advantages}
                />
              )}
            </div>
            <span className={styles.subtitle}>Price range</span>
            <div className={`${styles.priceRange} ${styles.separator}`}>
              <Input
                title={minText}
                IconRight={Currency}
                placeholder={'10'}
                onChange={(value) => formik.setFieldValue('from', value)}
                value={formik.values.from}
              />
              <Input
                title={maxText}
                IconRight={Currency}
                placeholder={'100'}
                onChange={(value) => formik.setFieldValue('to', value)}
                value={formik.values.to}
              />
            </div>
            <div className={`${styles.buttons} ${styles.separator}`}>
              <Button onClick={formik.handleSubmit}>{applyText}</Button>
              <Button
                className={styles.reset}
                variant={'text'}
                onClick={resetForm}
              >
                {resetText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FiltersBlock;
